import * as THREE from 'three/build/three.module';
import { J3PanelBase } from './J3PanelBase';
import { MapRefPoints, MapRefElement, Direction, ObjXZ, MapData } from './J3TypeList';

export class J3MapPanel extends J3PanelBase{
    section:HTMLElement = null;
    mapDiv:HTMLElement = null;
    mapImg:HTMLImageElement;
    //mapOverlay:HTMLElement;
    playerImg:HTMLImageElement;   //ユーザ画像
    xp:number = 1.0;    //座標変換用ファクタ X軸
    xq:number = 0.0;    //座標変換定数 X軸
    zp:number = 1.0;    //座標変換用ファクタ Z軸
    zq:number = 0.0;    //座標変換定数 Z軸
    playerScale:ObjXZ = {x:16, z:16}; //プレーヤー画像の表示サイズ
    refP:MapRefElement;
    refQ:MapRefElement;
    fx:number;
    fz:number;
    xdir:Direction = 'horizontal';
    offset:number = 0;
    mapData:MapData;    //マップデータ

    constructor(debugLvl = 0, name='', enable=true, show = true, visible=true, mapData:MapData, sectionID:string='side', mapAlt='マップ', btnContainerID:string = 'header_ul', onOffButtonID:string = 'icn_map', iconOnFile:string, iconOffFile:string, public mapClass:string = 'map'){

        super();
        this.name = name;
        this.mapData = mapData;
        if(enable){
            // ナビゲーション・ボタン
            const btnContainer = document.querySelector('#' + btnContainerID) as HTMLElement;
            if(btnContainer){
                /*
                //ボタンDOM構造
                <div class="header_nav">
		            <ul id="header_ul" class="list-inline hover"> //既存要素
			            <li id="icn_map">
                            //ここにオンオフボタンを作成
                        </li>
		            </ul>
	            </div>
                */
                const li = document.createElement('li');
                li.setAttribute("id", onOffButtonID);   //li要素にIDを追加
                this.MakeOnOffButtonDOM(li, iconOnFile, iconOffFile);
                btnContainer.appendChild(li);
                this.SetButtons(onOffButtonID);

                //メニューの表示・非表示
                if (visible){
                    this.ShowButton(li);
                }else{
                    this.HideButton(li);
                }
            }

            //サイドメニュー マップ表示
            this.section = document.querySelector('#' + sectionID) as HTMLElement;
            if(this.section){
                /*
                //マップDOM構造
                <div id="sidenav" class="side_nav"> //既存要素 #sidenav
		            <!-- 左右のセクションナビ -->
		            <!-- EXITボタン＋マップ 220831追加 -->	
		            <div class="map">
                        <img src="img/map.png" alt="マップ">
                        <div class="map_overlay"></div>
                    </div>
	            </div>
                */
               //マップのDOM要素を作成
                this.mapDiv = document.createElement('div');
                this.mapDiv.classList.add(mapClass);
                //this.mapOverlay  = document.createElement('div'); //マップのオーバーレイ・レイヤ
                //this.mapOverlay.setAttribute("id", 'map_overlay');
                this.mapImg = document.createElement('img') as HTMLImageElement;    //width, heightを取得するため HTMLImageElementにキャスト
                this.mapImg.alt = mapAlt;

                //DOM構造を最下位から作成
                
                this.mapDiv.appendChild(this.mapImg);
                //this.mapDiv.appendChild(this.mapOverlay);
                this.section.appendChild(this.mapDiv);
                this.SetOnOffTarget(this.mapDiv, false);    //表示／非表示する対象を設定
            }

            //初期状態
            console.log('J3MapPanel', show);
            if (show) {
                this.Show();
            } else {
                this.Hide();
            }
        }
    }

    ChangeMappingParams(index:number){
        if(index == null || index<0 || index > this.mapData.length-1) return;
        this.mapImg.src = this.mapData[index].imageFile; //index:floorIndex 初期設定値は0
        const refPoints:MapRefPoints = this.mapData[index].refPoints;
        console.log('refPoints', refPoints.xdir, refPoints.offset);

        this.xdir = refPoints.xdir; //X方向はマップの水平'horizontal'か垂直'vertical'か
        this.offset = refPoints.offset; //プレーヤ表示の回転角度オフセット（deg）
        this.refP = refPoints.p; //マップの座標変換ポイント１
        this.refQ = refPoints.q; //マップの座標変換ポイント２
        if(this.xdir == 'horizontal'){
            this.fx = (this.refQ.image[0]-this.refP.image[0])/(this.refQ.real[0] - this.refP.real[0]);     //画像幅/実長さ（幅方向）
            this.fz = (this.refQ.image[1]-this.refP.image[1])/(this.refQ.real[1] - this.refP.real[1]);    //画像高さ/実長さ（高さ方向）     
        }else{
            this.fx = (this.refQ.image[0]-this.refP.image[0])/(this.refQ.real[1] - this.refP.real[1]);     //画像幅/実長さ（幅方向）
            this.fz = (this.refQ.image[1]-this.refP.image[1])/(this.refQ.real[0] - this.refP.real[0]);    //画像高さ/実長さ（高さ方向）    
        }
        //ユーザー位置表示用の設定
        //console.log('mapImg width, height', this.mapImg.width, this.mapImg.height);
        //console.log('SetMappingParams', refPoints);
    }

    SetMappingParams(index:number=0, userImageFile:string, scale={x:16, z:16}){
        if(!this.mapDiv) return;
        this.ChangeMappingParams(index);

        //ユーザー表示用画像
        this.playerScale = scale;
        this.playerImg = document.createElement('img') as HTMLImageElement;
        this.playerImg.src = userImageFile;
        this.playerImg.setAttribute("id", 'player');
        this.playerImg.style.display = 'None';
        
        this.mapDiv.appendChild(this.playerImg);
    }

    Dn(value:number, digits = 2){
        return value.toFixed(digits);
    }

    PlotPosition(position:THREE.Vector3, azimuthAngle:number = 90){
        //console.log('position', this.Dn(position.x), this.Dn(position.y), this.Dn(position.z), 'angle', this.Dn(azimuthAngle));
        //this.mapDiv.style.width = this.mapImg.width.toString() + 'px';
        //console.log('mapDiv width', this.mapDiv.clientWidth, 'height', this.mapDiv.clientHeight);   //マップ画像の縦横サイズ（px）
        //const mapDiv = this.section.getElementsByClassName('map')[0] as HTMLElement;
        //const mapImg = this.section.getElementsByTagName('img')[0] as HTMLImageElement;

        //const widthOffset = 0;
        //console.log('client width/height', this.mapDiv.clientWidth, this.mapDiv.clientHeight);
        //console.log('mapImg & player width/height', this.mapImg.width, this.mapImg.height, this.playerImg.width, this.playerImg.height);
        
        //実座標XYからマップ上の座標に変換、プロットする
        let xmap:number;
        let zmap:number;
        let widthOffset = 0;
        if (this.mapClass == 'map') {
            widthOffset = this.mapDiv.clientWidth - this.mapImg.width;    //レスポンシブル時のずれ分をもとめておく
        }
        const mapFx = this.mapImg.width/this.mapImg.naturalWidth;   //現在の画像サイズと元の画像サイズの比
        const mapFz = this.mapImg.width/this.mapImg.naturalWidth;   //現在の画像サイズと元の画像サイズの比
        //console.log('mapFactor',mapFactor);
        if(this.xdir == 'horizontal'){
            //this.fx = (this.refQ.image[0]-this.refP.image[0])/(this.refQ.real[0] - this.refP.real[0]);     //画像幅/実長さ（幅方向）
            //this.fz = (this.refQ.image[1]-this.refP.image[1])/(this.refQ.real[1] - this.refP.real[1]);    //画像高さ/実長さ（高さ方向）   
            xmap = mapFx*((position.x - this.refQ.real[0]) * this.fx + this.refQ.image[0]);
            zmap = mapFz*((position.z - this.refQ.real[1]) * this.fz + this.refQ.image[1]);
        }else{
            //this.fx = (this.refQ.image[0]-this.refP.image[0])/(this.refQ.real[1] - this.refP.real[1]);     //画像幅/実長さ（幅方向）
            //this.fz = (this.refQ.image[1]-this.refP.image[1])/(this.refQ.real[0] - this.refP.real[0]);    //画像高さ/実長さ（高さ方向）   
            xmap = mapFx*((position.z - this.refQ.real[1]) * this.fx + this.refQ.image[0]);
            zmap = mapFz*((position.x - this.refQ.real[0]) * this.fz + this.refQ.image[1]);
        }
        //console.log(position.x, position.z, 'to', xmap, zmap);
        

        //const playersize = this.mapImg.width * 0.2; //プレーヤー画像のサイズをマップ幅の20%に
        //this.playerImg.width = playersize;
        //this.playerImg.height = playersize;
        //this.playerImg.width = this.playerScale.x;
        //this.playerImg.height = this.playerScale.z;

        //マップ画像外のときはプレーヤーを表示しない
        if(xmap<0 || xmap>this.mapImg.width || zmap<0 || zmap>this.mapImg.height){
            this.playerImg.style.display = 'None';
        }else{
            this.playerImg.style.display = 'Block';
        }

        var left =  ( widthOffset + xmap - this.playerImg.width/2);
        var right = ((this.mapImg.width - xmap) - this.playerImg.width/2);
        var top = (zmap - this.playerImg.height/2);
        if(this.debugLvl > 2) console.log('map left', left, 'right', right, 'top', top);
        //this.playerImg.style.left =  ( widthOffset + xmap - this.playerImg.width/2).toString() + 'px';
        //this.playerImg.style.left =  ( widthOffset + xmap ).toString() + 'px';
        //this.playerImg.style.top = (zmap - this.playerImg.height/2).toString() + 'px';

        this.playerImg.style.left = left.toString() + 'px';
        //this.playerImg.style.right = right.toString() + 'px';
        this.playerImg.style.top = top.toString() + 'px';

        //方向
        let angleDeg:number = azimuthAngle * 180.0/Math.PI + this.offset;
        
        this.playerImg.style.transform = "rotate(" + angleDeg + "deg)";

    }
}
